module.exports = "<!-- <button class=\"btn btn-primary btn-lg \" (click)= \"\" id=\"playButton\">Play Interval</button> -->"


//////////////////
// WEBPACK FOOTER
// /Users/ericzayas/Documents/relativePitch/src/app/components/generate-scale/generate-scale.component.html
// module id = ../../../../../src/app/components/generate-scale/generate-scale.component.html
// module chunks = main